import { defineMessages } from 'react-intl';

export default defineMessages({
  billers: {
    id: 'billers.list',
    defaultMessage: 'Billers List',
  },
  no: {
    id: 'billers.table.label.no',
    defaultMessage: 'No',
  },
  billerId: {
    id: 'billers.table.label.billerId',
    defaultMessage: 'Billers ID',
  },
  billerName: {
    id: 'billers.table.label.billerName',
    defaultMessage: 'Billers Name',
  },
  billerIcon: {
    id: 'billers.table.label.billerIcon',
    defaultMessage: 'Billers Icon',
  },
  billerStatus: {
    id: 'billers.table.label.billerStatus',
    defaultMessage: 'Billers Status',
  },
  billerAction: {
    id: 'billers.table.label.billerAction',
    defaultMessage: 'Action',
  },
  service: {
    id: 'billers.table.label.service',
    defaultMessage: 'Service Name',
  },
  playgroundStatus: {
    id: 'billers.table.label.playgroundStatus',
    defaultMessage: 'Playground Status',
  },
  skywalkerStatus: {
    id: 'billers.table.label.skywalkerStatus',
    defaultMessage: 'Skywalker Status',
  },
});
